import React from 'react'
interface Props {
  styleCssImage: string
  onClick?: () => void
}

const DropDown: React.FC<Props> = ({ styleCssImage, onClick }) => {
  return (
    <svg onClick={onClick}
    className={`${styleCssImage}  fill-[#0C266C]`}
     width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2823 11.2125L12.5844 15.9104L7.88653 11.2125C7.56966 10.8956 7.05453 10.8956 6.73766 11.2125C6.42078 11.5294 6.42078 12.0445 6.73766 12.3614L12.0075 17.6313C12.1668 17.7905 12.3764 17.8701 12.5844 17.8685C12.794 17.8685 13.002 17.7905 13.1613 17.6313L18.4312 12.3614C18.748 12.0445 18.748 11.5294 18.4312 11.2125C18.1143 10.8956 17.5992 10.8956 17.2823 11.2125Z"
        // fill="#0C266C"
      />
    </svg>
  )
}
export default DropDown
